<template>
  <section class="views">
    <!-- header -->
    <headers select="4"></headers>

    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/pcbanner.jpg')"
      />
      <div class="posters_ewm" v-if="false">
        <div class="ewm">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/csewm.png')" alt="" />
            </div>
            <div class="ewm3_value">掃碼報名比賽</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 比赛类型Tab -->
    <!-- <div class="competition-types">
      <div class="type-tabs">
        <div
          v-for="item in competitionType"
          :key="item.value"
          @click="changeCompetition(item.value)"
          :class="{ active: item.value === currentCompetition }"
          class="tab-item"
        >
          {{ item.title }}
        </div>
      </div>
    </div> -->

    <div class="content">
      <div class="viewsBoxTab">
        <div class="viewsTab">
          <ul>
            <li
              v-for="(item, index) in tabColumns"
              :key="index"
              @click="tabBut(index)"
              :class="select == index ? 'select' : ''"
            >
              <div>{{ item.name }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="shortlisted-query" v-if="select === 0">
        <div class="contentFrom_title">入圍名單查詢</div>
        <div class="plateUlsCentent6">
          <ul>
            <li>
              <div class="prompt" style="cursor: pointer">
                <div
                  :class="choose == 0 ? 'highlight' : ''"
                  @click="chooseBut(0)"
                >
                  個人報名
                </div>
                <div
                  :class="choose == 1 ? 'highlight' : ''"
                  @click="chooseBut(1)"
                >
                  學校報名
                </div>
              </div>
              <div class="promptInput2" v-if="choose == 0">
                <div class="lis">
                  <div class="lisLife">
                    <!-- <img :src="require('@/assets/image/hk.png')" />
                  <span>+852</span> -->
                    <CountryCodeSelector
                      :searchbar="false"
                      :countryCode.sync="prefix"
                      style="width: 80px; margin-right: 5px"
                    ></CountryCodeSelector>
                  </div>
                  <div class="lisRight">
                    <input
                      type="text"
                      placeholder="請輸入參賽電話號碼"
                      value=""
                      v-model.trim="from.phone"
                    />
                  </div>
                </div>
              </div>
              <div class="promptInput" v-if="choose == 1">
                <input
                  placeholder="請輸入學校編號"
                  v-model.trim="from.schoolCode"
                />
              </div>
            </li>
            <template v-if="choose == 1">
              <li>
                <div class="promptInput">
                  <input
                    placeholder="請輸入登入編號"
                    v-model="from.studentCode"
                  />
                </div>
              </li>
              <!-- <li>
                <div class="promptInput">
                  <input placeholder="請輸入學生密碼" v-model="from.password" />
                </div>
              </li> -->
            </template>
            <li>
              <div class="promptInput">
                <input
                  placeholder="請輸入參賽者姓名"
                  v-model="from.school_name"
                />
              </div>
            </li>
          </ul>

          <div
            class="but"
            @click="finalistsBut ? onFinalists() : ''"
            style="cursor: pointer"
          >
            查詢
          </div>
        </div>
      </div>
      <div class="viewTabContent">
        <div class="ulsTab" ref="tabSlideTwo">
          <ul>
            <li
              v-for="(item, index) in tabColumns[select].dataTab"
              :key="index"
              :class="selectTwo == item.id ? 'select' : ''"
              @click="tabButTwo(item.id)"
              :ref="`tab${index}RefTwo`"
              v-if="index <= 5"
            >
              <div>{{ item.name }}</div>
              <div>（{{ item.fzhu }}）</div>
            </li>
          </ul>
          <ul style="margin-top: 10px;">
            <li
              v-for="(item, index) in tabColumns[select].dataTab"
              :key="index"
              :class="selectTwo == item.id ? 'select' : ''"
              @click="tabButTwo(item.id)"
              :ref="`tab${index}RefTwo`"
              v-if="index > 5"
            >
              <div>{{ item.name }}</div>
              <div>（{{ item.fzhu }}）</div>
            </li>
          </ul>
        </div>

        <div class="box">
          <ul
            v-if="
              select === 2 &&
              currentCompetition == '1' &&
              finalRankingList.length
            "
          >
            <li class="weiyitop">
              <div>獎項</div>
              <div>姓名</div>
              <div>電話/學號</div>
            </li>
            <li class="lis" v-for="(item, index) in finalRankingList" :key="index">
              <div>{{ item.award }}</div>
              <div>{{ item.studentName }}</div>
              <div>{{ getDisplayField(item) }}</div>
            </li>
          </ul>
          <ul v-else-if="select === 2">
            <div class="wu_center_custom">本組別暫無決賽成績。</div>
          </ul>
          <ul v-else-if="selectTwo === 10 && select === 0">
            <div class="wu_center_custom">經綜合評定，本組別參賽學生成績未達本次複賽入圍標準，很遺憾本屆暫無學生晉級複賽。</div>
          </ul>
          <ul v-else-if="selectTwo === 10 && select === 1">
            <div class="wu_center_custom">很遺憾本屆暫無學生晉級決賽。</div>
          </ul>
          <template v-else>
            <ul v-if="selectTwo !== 10 && currentCompetition == '1' && select !== 2">
              <li class="weiyitop">
                <div>參賽序號</div>
                <div>姓名</div>
                <div>電話/學號</div>
                <div v-if="select == 1">入圍/獎項</div>
              </li>

              <li class="lis" v-for="(item, index) in queryUserList" :key="index">
                <div>{{ item.competitionId }}</div>
                <div>{{ item.studentName }}</div>
                <div>{{ item.studentCode || item.phone }}</div>
                <div v-if="select == 1">
                  入圍決賽
                  <!-- {{
                    item.ranking <= 6
                      ? "入圍決賽"
                      : item.ranking >= 7 && item.ranking <= 10
                      ? "優異獎"
                      : ""
                  }} -->
                </div>
              </li>
            </ul>
          </template>
          <!-- <ul v-else-if="currentCompetition == '2' && select == 0">
            <li class="weiyitop">
              <div>序號</div>
              <div>學校/機構名</div>
              <div>入圍/獎項</div>
            </li>

            <li class="lis" v-for="(item, index) in queryUserList" :key="index">
              <div>{{ item.competitionId }}</div>
              <div>{{ item.agencyName }}</div>
              <div>
                {{ item.ranking <= 3 ? "入圍決賽" : "優異獎" }}
              </div>
            </li>
          </ul> -->
          
           <!-- <ul v-else-if="currentCompetition == '2' && select == 1">
            <li class="weiyitop">
              <div>獎項</div>
              <div style="width: 66%">學校/機構名</div>
            </li>
            <li
              class="lis"
              v-for="(item, index) in rankingUserList"
              :key="index"
            >
              <div>
                {{
                  index == 0
                    ? "金獎"
                    : index == 1
                    ? "銀獎"
                    : index == 2
                    ? "銅獎"
                    : "優異獎"
                }}
              </div>
              <div style="width: 66%">{{ item.agencyName }}</div>
            </li>
          </ul> -->
          <!-- <ul v-else-if="currentCompetition == '1' && select == 2">
            <li class="weiyitop">
              <div>獎項</div>
              <div>姓名</div>
              <div>電話/學號</div>
            </li>
            <li
              class="lis"
              v-for="(item, index) in rankingUserList"
              :key="index"
            >
              <div v-if="item.competitionId === 22687">
                {{
                  "優異獎"
                }}
              </div>
               <div v-else>
                {{
                  index == 0 ? "金獎" : [1, 2].includes(index) ? "銀獎" : [3, 4, 5].includes(index) ? "銅獎" : "優異獎"
                }}
              </div>
              <div>{{ item.studentName }}</div>
              <div>{{ item.studentCode || item.phone }}</div>
            </li>
          </ul> -->
          <!-- <ul v-if="select === 2">
            <li class="weiyitop">
              <div>獎項</div>
              <div>姓名</div>
              <div>電話/學號</div>
            </li>
            <li class="lis" v-for="(item, index) in queryUserList" :key="index">
              <div>
                {{
                  item.ranking == 1
                    ? '金獎'
                    : item.ranking == 2
                    ? '銀獎'
                    : item.ranking == 3
                    ? '銅獎'
                    : item.ranking > 3
                    ? '優異獎'
                    : ''
                }}
              </div>
              <div>{{ item.studentName }}</div>
              <div>{{ item.phone }}</div>
            </li>
          </ul> -->
        </div>
      </div>

      <!-- 佔位 -->
      <div style="margin-top: 20px; width: 100%"></div>
    </div>

    <div class="generateHeats">
      <!-- 未入圍/成功入園 -->
      <van-popup v-model="newShortZZC" :round="true" :lock-scroll="false">
        <div class="newShortBox">
          <div class="list" v-if="newShortActive == 1">
            <!-- <div class="lis lisCenten"> <van-image width="149px" :src="require('@/assets/image/fusai/yes.png')" /> </div> -->
            <div class="ulst">
              <ul>
                <li>姓名</li>
                <li>組別</li>
                <li>分數</li>
              </ul>
              <ul>
                <li>
                  {{ userObj.studentName == null ? "" : userObj.studentName }}
                </li>
                <li>
                  {{
                    userObj.competitionGroup == null
                      ? ""
                      : userObj.competitionGroup
                  }}
                </li>
                <li>{{ userObj.score == null ? "" : userObj.score }}</li>
              </ul>
            </div>
            <div class="lis lisText">
            恭喜你，成功入圍複賽<br />
              <!-- <span v-if="userObj.finalStatus == 2"
                >恭喜您，成功入圍決賽，<br />請仔細閱讀入圍電郵。</span
              >
              <span
                v-else-if="
                  userObj.finalStatus == 1 &&
                    userObj.ranking >= 7 &&
                    userObj.ranking <= 10
                "
                >您的成績未能入圍決賽，<br />獲得優異獎。</span
              >
              <span v-else
                >很遺憾，您的成績未能獲獎，<br />非常感謝您的參與。</span
              > -->
            </div>
            <!-- <div class="view_guide" @click="generateHeatsZZC = true" v-if="select == 0">
              點擊查看決賽指引
            </div> -->
          </div>

          <div class="list" v-if="newShortActive == 2">
            <div class="ulst">
              <ul>
                <li>姓名</li>
                <li>組別</li>
                <li>分數</li>
              </ul>
              <ul>
                <li>
                  {{ userObj.studentName == null ? "" : userObj.studentName }}
                </li>
                <li>
                  {{
                    userObj.competitionGroup == null
                      ? ""
                      : userObj.competitionGroup
                  }}
                </li>
                <li>{{ userObj.score == null ? "" : userObj.score }}</li>
              </ul>
            </div>
            <div class="lis lisText">
            很遗憾，您的成績未能入圍複賽，<br />非常感謝您的參與。
              <!-- <span v-if="userObj.finalStatus == 2"
                >恭喜您，成功入圍決賽，<br />請仔細閱讀入圍電郵。</span
              >
              <span
                v-else-if="
                  userObj.finalStatus == 1 &&
                    userObj.ranking >= 7 &&
                    userObj.ranking <= 10
                "
                >您的成績未能入圍決賽，<br />獲得優異獎。</span
              >
              <span v-else
                >很遺憾，您的成績未能獲獎，<br />非常感謝您的參與。</span
              > -->
            </div>
          </div>
        </div>
      </van-popup>

      <!-- 複賽指引 -->
      <van-popup v-model="generateHeatsZZC" :round="true" :lock-scroll="false">
        <div class="generateHeatsBox">
          <div class="uls">
            <div class="titleH1">
              <div class="left_icon">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="title">複賽指引</div>
              <div class="right_icon">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            <div class="textCentent">
              <div class="color1 font_size1" style="margin-bottom: 6px">
                請按照下方參賽影片要求進行錄製，否則將影響評分。如提交影片遇到困難，請于活動頁左下方WhatsApp進行留言，主辦機構中文路ChineseRd將會提供支援。
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                *凡是參賽的選手，等同於同意主辦機構中文路ChineseRd將此次參賽影片使用於全媒體渠道展示宣傳。
                <br />
                *為免遇上網絡擠塞，請預留好上載複賽影片的時間。
                <br />
                *所有參賽影片錄製必須為參賽者本人，如審核發現非參賽者本人錄製之情況，將予以失格公示。
                <br />
              </div>
              <div class="titleRed">【參賽影片要求】</div>
              <div class="color1 font_size1" style="margin-bottom: 6px">
                1. 參賽者應依照以下次序錄製影片：
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ①
                用普通話進行自我介紹，包含姓名、組別、來自哪一間幼稚園/小學/中學等。
                <br />
                ②
                用普通話讀出比賽誦材之標題及作者（如若誦材未標明作者，可以只讀誦材標題）。
                <br />
                ③ 用普通話朗誦誦材內容一次。
                <br />
                ④ <span class="color1" style="font-weight: 600;">參賽者必須背誦誦材</span>，違者將只獲評語，沒有評級，亦不獲發獎狀。
                <br />
                ⑤ 如參賽者於影片中重複演繹同一作品，只有首次演繹獲得評審。
                <br />
                ⑥ 請使用<span class="color1" style="font-weight: 600;">豎屏</span>拍攝。
                <br />
                ⑦ 影片時長要求：閃亮組、飛躍組、幼稚園組、小學初級、中級組：3 分鐘以內；小學高級組、中學組：6 分鐘以內。
                <br />
              </div>
              <div class="color1 font_size1" style="margin-bottom: 6px">
                2. 參賽者必須根據以下指引，否則將影響評分：
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ① 參賽者錄製參賽影片時請注意着裝得體。
                <br />
                ② 整段影片須清楚顯示參賽者之全身、樣貌及動作。
                <br />
                ③
                拍攝影片時，應保持拍攝鏡頭穩定及定鏡拍攝，不應移動、推進及拉近鏡頭。
                <br />
                ④
                為確保影片聲畫同步、畫面與聲音清晰和流暢，影⽚解像度為720p(1280x720)或以上。
                <br />
                ⑤
                在室內以簡單背景和寧靜的環境下拍攝，並確保光度充足，避免背光、使用虛擬或投射背景。
                <br />
                ⑥ 參賽者不應使用任何款式耳機作為收音用途。
                <br />
                ⑦ 拍攝影片時請勿使用擴音器。
                <br />
              </div>

              <div class="color1 font_size1" style="margin-bottom: 6px">
                3. 參賽者必須跟隨以下指引，否則將被取消資格：
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ① 影片必須為一鏡到底的拍攝原片，拍攝途中不可暫停攝影機。
                <br />
                ②
                影片中不可加入特別效果，例如濾鏡、過渡、調色、調光、字幕等，亦不得進行任何混音、剪接及後期製作。
                <br />
                ③ 影片必須是現場收音及錄像，不可配音。
                <br />
              </div>
              <div class="titleRed">【影片上傳要求】</div>
              <div class="font_size2" style="margin-bottom: 20px">
                <span class="color1"
                  >① 參賽者須通過 <span class="color1" style="font-weight: 600;">官方活動網站：</span>https://speech.chineserd.com 或 <span class="color1" style="font-weight: 600;">中文路App：</span>ChineseRd Plus 上傳參賽影片。</span
                >
                <br />
                <span class="color1"
                  >② 參賽者有責任確保以下資料正確，包括：</span
                >
                <br />
                <span class="color2">
                  網頁中的各項資料正確。如發現資料有誤，請于活動頁左下方WhatsApp進行留言，主辦機構中文路ChineseRd將會提供支援，根據指引於限期內重新提交。
                </span>
                <br />
                <span class="color2"
                  >所提交的影片須與參賽者及其比賽項目相符。如記錄不符，評審團有權不評審相關影片。</span
                >
                <br />
                <span class="color1"
                  >③ 如重複提交，將以最後一次符合提交條件的記錄為準。</span
                >
                <br />
                <span class="color1"
                  >④
                  如評審期內因任何原因，影片未能播放，不會就此作個別通知，參賽者將不獲評分（評級）或獎狀。</span
                >
                <br />
              </div>
              <div class="but" @click="handleUploadVideo()">
                <img :src="require('@/assets/image/fusai/yunshang.png')" />
                點擊上載視頻
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import CountryCodeSelector from "@/components/CountryCodeSelector";

const FINAL_RESULT_MAP = {
  1: [
    { award: "金獎", studentName: "魏家沛", studentCode: "HLKG003", phone: "++852-55429521" },
    { award: "銀獎", studentName: "王詩琳", phone: "+852-63601516" },
    { award: "銀獎", studentName: "陳欣芸", studentCode: "wghckhkg-4", phone: "++852-95422836" },
    { award: "銅獎", studentName: "游雅媛", studentCode: "HLKG002", phone: "++852-55429521" },
    { award: "銅獎", studentName: "黃慕恆", phone: "+852-91455252" },
    { award: "銅獎", studentName: "馬樂賢", phone: "+852-53699348" },
    { award: "優異獎", studentName: "徐艾辰", phone: "+852-67631166" },
    { award: "優異獎", studentName: "李文采", phone: "+852-95770608" },
    { award: "優異獎", studentName: "顏語瑞", studentCode: "HLKG004", phone: "++852-55429521" },
    { award: "優異獎", studentName: "何玥蓉", phone: "+852-70102095" },
  ],
  2: [
    { award: "金獎", studentName: "杜祉穎", phone: "****2803" },
    { award: "銀獎", studentName: "高研芯", phone: "****2152" },
    { award: "銅獎", studentName: "劉星瑤", phone: "****2803" },
    { award: "銅獎", studentName: "石智宇", phone: "****0608" },
    { award: "銅獎", studentName: "董鈺瑩", phone: "****2803" },
    { award: "優異獎", studentName: "沈因時", studentCode: "*i5", phone: "" },
    { award: "優異獎", studentName: "韋昊瑜", phone: "****2198" },
    { award: "優異獎", studentName: "李沐苒", phone: "****6560" },
    { award: "優異獎", studentName: "肖芊玥", phone: "****0608" },
  ],
  3: [
    { award: "金獎", studentName: "江韋孜", studentCode: "wkf20251053", phone: "++852-59311212" },
    { award: "銀獎", studentName: "張凱傑", studentCode: "AAPS05", phone: "++852-90125523" },
    { award: "銀獎", studentName: "梁鈞甯", phone: "+852-59635863" },
    { award: "銅獎", studentName: "張芊雪", phone: "+852-64075156" },
    { award: "銅獎", studentName: "陸憬翌", phone: "+852-56668570" },
    { award: "銅獎", studentName: "袁梓菡", phone: "+852-98620293" },
    { award: "優異獎", studentName: "韓悅晴", phone: "+852-54037521" },
    { award: "優異獎", studentName: "余梓瑤", phone: "+852-59839591" },
    { award: "優異獎", studentName: "蘇珮博", phone: "+852-96188158" },
    { award: "優異獎", studentName: "梁浚桻", phone: "+852-56085530" },
  ],
  4: [
    { award: "金獎", studentName: "周天易", phone: "+852-63551653" },
    { award: "銀獎", studentName: "李芃萱", phone: "+852-70841672" },
    { award: "銀獎", studentName: "徐洛晞", phone: "+852-62056028" },
    { award: "銅獎", studentName: "葉峻銘", phone: "+86-13924598675" },
    { award: "銅獎", studentName: "陳欣妤", phone: "+852-96599969" },
    { award: "銅獎", studentName: "周思遠", phone: "+852-67483765" },
    { award: "優異獎", studentName: "李凌菲", phone: "+852-95890188" },
    { award: "優異獎", studentName: "黎睿知", phone: "+852-61396102" },
    { award: "優異獎", studentName: "徐嘉躍", phone: "+852-97111990" },
    { award: "優異獎", studentName: "何曾柳", phone: "+852-70102095" },
  ],
  5: [
    { award: "金獎", studentName: "陳旺田", phone: "+852-59566729" },
    { award: "銀獎", studentName: "林珏鋒", phone: "+852-56206168" },
    { award: "銀獎", studentName: "陳梓琳", phone: "+852-54096542" },
    { award: "銅獎", studentName: "蔡鎬宇", phone: "+852-66769854" },
    { award: "銅獎", studentName: "羅樂誠", phone: "+852-68997872" },
    { award: "銅獎", studentName: "盛糖", phone: "+852-55133400" },
    { award: "優異獎", studentName: "彭一心", phone: "+852-94899868" },
    { award: "優異獎", studentName: "方敏祺", phone: "+852-54815743" },
  ],
  6: [
    { award: "金獎", studentName: "王睿澤", phone: "+852-56393626" },
    { award: "銀獎", studentName: "王語淇", phone: "+852-61953130" },
    { award: "銀獎", studentName: "徐姜屹", phone: "+852-66417226" },
    { award: "銅獎", studentName: "王婧琪", studentCode: "S23162", phone: "++86-13410580909" },
    { award: "銅獎", studentName: "劉子清", phone: "+852-70105292" },
    { award: "銅獎", studentName: "張雅婷", phone: "+852-54486881" },
    { award: "優異獎", studentName: "黎諾源", phone: "****6910" },
    { award: "優異獎", studentName: "郭雯欣", phone: "+852-96090402" },
    { award: "優異獎", studentName: "譚天", studentCode: "s241225", phone: "++852-66326693" },
  ],
  7: [
    { award: "金獎", studentName: "許銘賢", studentCode: "hclmhmy", phone: "++852-53164099" },
    { award: "銀獎", studentName: "楊大福", studentCode: "hcwmc5", phone: "++852-66819100" },
    { award: "銅獎", studentName: "吳玥瑾", studentCode: "hcwmc3", phone: "++852-66819100" },
    { award: "優異獎", studentName: "黃子雲", studentCode: "hclmwtw", phone: "++852-61792818" },
    { award: "優異獎", studentName: "譚梓詠", studentCode: "hclmttw", phone: "++852-64800240" },
    { award: "優異獎", studentName: "吳素馨", studentCode: "hclmnsh", phone: "++852-64800240" },
  ],
  9: [
    { award: "金獎", studentName: "張婷婷", phone: "+852-69791589" },
    { award: "銀獎", studentName: "羅梓傑", phone: "****0748" },
    { award: "銅獎", studentName: "郭柏賢", phone: "+852-95770608" },
    { award: "優異獎", studentName: "羅梓晴", phone: "****0748" },
    { award: "優異獎", studentName: "高艾娜", studentCode: "Lyla", phone: "++852-92882803" },
    { award: "優異獎", studentName: "Lumisa Thapa", studentCode: "63088224", phone: "++852-95226755" },
  ],
  10: [],
  11: [
    { award: "金獎", studentName: "娜薇雅", studentCode: "20248006", phone: "++852-68599292" },
    { award: "銀獎", studentName: "尚康賢", studentCode: "20227033", phone: "++852-63001175" },
    { award: "銅獎", studentName: "NARAYANAN Vishwa", studentCode: "20227029", phone: "++852-63978856" },
    { award: "優異獎", studentName: "馮晉", phone: "+852-63454745" },
    { award: "優異獎", studentName: "龔芷澄", studentCode: "20237006", phone: "++852-64612829" },
    { award: "優異獎", studentName: "Kim Yungbin", phone: "+852-68105452" },
  ],
};

export default {
  name: "signup",
  components: {
    headers,
    CountryCodeSelector,
  },
  data() {
    return {
      generateHeatsZZC: false, //複賽指引
      // 比赛类型
      currentCompetition: "1",
      competitionType: [
        {
          title: "個人賽",
          value: "1",
        },
        {
          title: "團體赛",
          value: "2",
        },
      ],
      tabColumns1: [
        {
          id: "0",
          name: "初賽成績",
          dataTab: [
            {
              name: "幼稚園初級組",
              fzhu: "K1-K2",
              id: 1,
            },
            {
              name: "幼稚園高級組",
              fzhu: "K3",
              id: 2,
            },
            {
              name: "小學初級組",
              fzhu: "P1-P2",
              id: 3,
            },
            {
              name: "小學中級組",
              fzhu: "P3-P4",
              id: 4,
            },
            {
              name: "小學高級組",
              fzhu: "P5-P6",
              id: 5,
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              id: 6,
            },
            {
              name: "閃亮組",
              fzhu: "特殊學校",
              id: 7,
            },
            {
              name: "飛躍A組",
              fzhu: "非華裔-幼稚園",
              id: 9,
            },
            {
              name: "飛躍B組",
              fzhu: "非華裔-小學",
              id: 10,
            },
            {
              name: "飛躍C組",
              fzhu: "非華裔-中學",
              id: 11,
            },
          ],
        },
        {
          id: "1",
          name: "複賽成績",
          dataTab: [
            {
              name: "幼稚園初級組",
              fzhu: "K1-K2",
              id: 1,
            },
            {
              name: "幼稚園高級組",
              fzhu: "K3",
              id: 2,
            },
            {
              name: "小學初級組",
              fzhu: "P1-P2",
              id: 3,
            },
            {
              name: "小學中級組",
              fzhu: "P3-P4",
              id: 4,
            },
            {
              name: "小學高級組",
              fzhu: "P5-P6",
              id: 5,
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              id: 6,
            },
            {
              name: "閃亮組",
              fzhu: "特殊學校",
              id: 7,
            },
            {
              name: "飛躍A組",
              fzhu: "非華裔-幼稚園",
              id: 9,
            },
            {
              name: "飛躍B組",
              fzhu: "非華裔-小學",
              id: 10,
            },
            {
              name: "飛躍C組",
              fzhu: "非華裔-中學",
              id: 11,
            },
          ],
        },
        {
          id: "2",
          name: "決賽成績",
          dataTab: [
            {
              name: "幼稚園初級組",
              fzhu: "K1-K2",
              id: 1,
              // competitionId: [18271, 19815, 18270, 21748, 18294, 21291],
            },
            {
              name: "幼稚園高級組",
              fzhu: "K3",
              id: 2,
              // competitionId: [19820, 19235, 19818, 18303, 19797, 21484],
            },
            {
              name: "小學初級組",
              fzhu: "P1-P2",
              id: 3,
              // competitionId: [18498, 20958, 18552, 21780, 20825, 18590],
            },
            {
              name: "小學中級組",
              fzhu: "P3-P4",
              id: 4,
              // competitionId: [18376, 18447, 20005, 18366, 21545, 18298],
            },
            {
              name: "小學高級組",
              fzhu: "P5-P6",
              id: 5,
              // competitionId: [19782, 22368, 22327, 21334, 21767, 20439],
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              id: 6,
              // competitionId: [22242, 18587, 20154, 20158, 22082, 20159],
            },
            {
              name: "閃亮組",
              fzhu: "特殊學校",
              id: 7,
              // competitionId: [21197, 22684, 22685, 22768, 22769],
            },
            {
              name: "飛躍A組",
              fzhu: "非華裔-幼稚園",
              id: 9,
            },
            {
              name: "飛躍B組",
              fzhu: "非華裔-小學",
              id: 10,
            },
            {
              name: "飛躍C組",
              fzhu: "非華裔-中學",
              id: 11,
            },
          ],
        },
      ],
      tabColumns2: [
        {
          id: "0",
          name: "初賽成績",
          dataTab: [
            {
              name: "幼稚園組",
              fzhu: "K1-K3",
            },
            {
              name: "小學初級組",
              fzhu: "P1-P3",
            },
            {
              name: "小學高級組",
              fzhu: "P4-P6",
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
            },
          ],
        },
        {
          id: "2",
          name: "決賽成績",
          dataTab: [
            {
              name: "幼稚園組",
              fzhu: "K1-K3",
              competitionId: [92, 94, 96],
            },
            {
              name: "小學初級組",
              fzhu: "P1-P3",
              competitionId: [99, 125, 134],
            },
            {
              name: "小學高級組",
              fzhu: "P4-P6",
              competitionId: [126, 111, 110],
            },
            {
              name: "中學組",
              fzhu: "S1-S6",
              competitionId: [106, 120, 119],
            },
          ],
        },
      ],
      select: 2, // 0:初赛 1:复赛 2:决赛
      selectTwo: 1,
      choose: 0, //查詢的下標
      from: {
        school_name: null,
        email: null,
        phone: null,
      },
      prefix: 852,
      finalistsBut: true,
      newShortZZC: false, //入圍 彈窗
      newShortActive: 1,
      userObj: {
        competitionGroup: 1, //組別
        score: null, //分數
        studentName: null, //名字
      },
      queryUserList: [],
    };
  },

  computed: {
    tabColumns() {
      return this.currentCompetition === "1"
        ? this.tabColumns1
        : this.tabColumns2;
    },
    finalRankingList() {
      if (this.currentCompetition !== "1" || this.select !== 2) {
        return [];
      }
      return FINAL_RESULT_MAP[this.selectTwo] || [];
    },
  },
  created() {},
  mounted() {
    this.getScoreList(1);
  },
  methods: {
    handleUploadVideo() {
      this.$router.push({
        path: "/",
        query: {
          uploadVideo: true,
        },
      });
    },
    changeCompetition(value) {
      this.currentCompetition = value;
      if (this.currentCompetition == "1") {
        this.select = 2;
      } else {
        this.select = 1;
      }
      this.selectTwo = 1;
      // this.getScoreList(1);
    },
    // 组别切换
    tabButTwo(e) {
      this.selectTwo = e;
      this.getScoreList(1);
    },
    // 初复决切换
    tabBut(e) {
      this.select = e;
      this.selectTwo = 1;
      this.getScoreList(1);
    },
    // 切換
    chooseBut(e) {
      this.choose = e;
    },
    validator_email(val) {
      const email = val && val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    validator_phone(val) {
      const phone = val && val.trim();
      return /^[0-9]*$/.test(phone);
    },
    // 入圍按鈕提交
    onFinalists() {
      let params;

      if (this.choose == 0) {
        if (this.from.school_name == "" || this.from.school_name == null) {
          this.$toast("請輸入您的姓名 !");
          return;
        }
        // 手機
        if (!this.validator_phone(this.from.phone)) {
          this.$toast("手機號格式有誤 !");
          return;
        }

        params = {
          studentName: this.from.school_name,
          // prefix: this.prefix,
          phone: this.from.phone,
          email: null,
        };
      } else if (this.choose == 1) {
        const { schoolCode, studentCode, password, school_name } = this.from;
        if (schoolCode == "" || schoolCode == null) {
          this.$toast("請輸入學校編號 !");
          return;
        }
        if (studentCode == "" || studentCode == null) {
          this.$toast("請輸入登入編號 !");
          return;
        }
        // if (password == "" || password == null) {
        //   this.$toast("請輸入學生密碼 !");
        //   return;
        // }
        if (school_name == "" || school_name == null) {
          this.$toast("請輸入您的姓名 !");
          return;
        }

        params = {
          schoolCode,
          studentCode,
          password,
          studentName: school_name,
        };
      }

      params.scoreType = this.select + 1;
      params.competitionType = 8;
      this.finalistsBut = false;
      this.$toast.loading({
        message: "正在查詢中...",
        duration: 0,
        forbidClick: true,
      });

      this.$axios
        .post(this.$api.getPersonInfo, params)
        .then((response) => {
          this.finalistsBut = true;
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            this.userObj.competitionGroup = response.data.data.competitionGroup; //組別
            this.userObj.score = response.data.data.score; //分數
            this.userObj.studentName = response.data.data.studentName; //名字
            this.userObj.finalStatus = response.data.data.finalStatus; // 1是优异奖  2是入围决赛
            this.userObj.ranking = response.data.data.ranking;

            this.$toast.clear();
            if (response.data.data.shortlisted) {
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 1; //1是成功  2是失敗
            } else {
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 2; //1是成功  2是失敗
            }
          }
        })
        .catch((error) => {
          this.finalistsBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    getScoreList(pageNum) {
      if (this.currentCompetition === "1" && this.select === 2) {
        this.queryUserList = [];
        return;
      }
      this.$toast.loading({
        message: "正在查詢中...",
        duration: 0,
        forbidClick: true,
      });
      let groupId = this.selectTwo;
      let competitionType = this.currentCompetition === "1" ? 8 : 2;

      let scoreType = 1;
      if (this.currentCompetition === "1" && this.select != 0) {
        scoreType = 3;
      }

      let params =
        "?groupId=" +
        groupId +
        "&competitionType=" +
        competitionType +
        "&scoreType=" +
        scoreType +
        "&pageNum=" +
        pageNum +
        "&pageSize=" +
        100;
      if (this.select == 1) {
        params = params + "&ranking=" + 15;
      }
      const api =
        this.currentCompetition === "1"
          ? this.$api.promotionStudentList
          : this.$api.promotionCompetitionList;
      this.$axios
        .get(api + params)
        .then((response) => {
          this.$toast.clear();
          let arr = response.data.rows;
          if (pageNum === 1) {
            this.queryUserList = arr;
          } else {
            this.queryUserList = [...this.queryUserList, ...arr];
          }
          // 数据最多返回100条，超出请求2次
          if (response.data.total > 100 && pageNum === 1) {
            this.getScoreList(2);
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    getDisplayField(item) {
      if (item.studentCode) {
        const studentCode = String(item.studentCode).trim();
        return studentCode ? `*${studentCode.slice(-2)}` : "--";
      }

      if (item.phone) {
        const phone = String(item.phone).replace(/\D/g, "");
        return phone ? `****${phone.slice(-4)}` : "--";
      }

      return "--";
    },
  },
};
</script>

<style lang="scss" scoped>
.competition-types {
  position: sticky;
  top: 80px;
  width: 100%;
  margin-bottom: 30px;
  background: #d34a00;
  z-index: 99999;
  .type-tabs {
    display: flex;
    justify-content: center;
    gap: 10px;
    .tab-item {
      min-width: 120px;
      padding: 20px 10px;
      color: #fff;
      cursor: pointer;
      font-size: 16px;

      &.active {
        font-weight: 600;
        color: #903300;
        background-image: url("~@/assets/image/hodgepodge/tabbuttom.png");
        background-size: 100% 100%;
        transform: scale(1.2);
      }
    }
  }
}

.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      width: 1024px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            line-height: 19px;
            text-align: center;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    margin: auto;

    .viewsBoxTab {
      width: 100%;
      position: relative;
      background: linear-gradient(to bottom, #ffe082 0%, #efbb69 100%);
      // background: #d34a00;

      .viewsTab {
        width: 100%;
        max-width: 1024px;
        margin: auto;
        box-sizing: border-box;
        display: flex;

        ul {
          width: 100%;
          height: 64px;
          display: flex;
          justify-content: center;
          align-items: center;
          li {
            width: 152px;
            height: 100%;
            display: flex;
            align-content: center;
            align-items: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            flex: 0 0 auto;
            background: linear-gradient(to bottom, #ffe082 0%, #efbb69 100%);
            // background: #d34a00;
            cursor: pointer;

            div {
              width: 100%;
            }

            div:nth-child(1) {
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              // color: #ffffff;
              color: #903300;
            }

            div:nth-child(2) {
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              // color: #ffffff;
              color: #903300;
            }
          }

          .select {
            font-size: 16px;
            font-weight: 600;
            // color: #903300;
            color: #fff;
            background: linear-gradient(135deg, #ff8a3a 0%, #d34a00 100%);
            border-radius: 5px;
            box-shadow: 0 8px 20px rgba(211, 74, 0, 0.18), inset 0 -4px 12px rgba(255, 255, 255, 0.06);
            transform: translateZ(0) scale(1.04);
            transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
            // padding: 8px 0;
            // background: url("~@/assets/image/hodgepodge/tabbuttom.png")
            //   no-repeat;
            // background-size: 100% 100%;

            div:nth-child(1) {
              font-size: 16px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #fff;
            }

            div:nth-child(2) {
              font-size: 13px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #fff;
            }
          }
        }
      }
    }

    .viewTabContent {
      width: 100%;
      max-width: calc(100% - 40px);
      margin: auto;
      margin-top: 30px;
      box-sizing: border-box;

      .ulsTab::-webkit-scrollbar {
        display: none;
      }

      .ulsTab {
        width: 100%;
        box-sizing: border-box;
        ul {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;

          li {
            width: 115px;
            height: 66px;
            background: #ffffff;
            border: 2px solid #ffffff;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            line-height: 19px;
            text-align: center;
            border-radius: 16px;
            cursor: pointer;

            div:nth-child(1) {
              width: 100%;
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              color: #666666;
              line-height: 19px;
            }

            div:nth-child(2) {
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              color: #666666;
              margin-top: 2px;
            }
          }
          .select {
            background: #fdd472 !important;

            div:nth-child(1) {
              font-size: 16px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #903300 !important;
              line-height: 19px;
            }

            div:nth-child(2) {
              font-size: 13px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #903300 !important;
            }
          }
        }
      }

      .box {
        width: 700px;
        padding-top: 50px;
        margin: auto;
        box-sizing: border-box;

        ul::-webkit-scrollbar {
          display: none;
        }

        ul {
          width: 100%;
          height: 70vh;
          border-radius: 16px;
          background: #ffffff;
          border: 0.06rem solid #ffffff;
          box-sizing: border-box;
          overflow-x: hidden;
          position: relative;

          .wei {
            width: 100%;
            height: 46px;
          }

          .weiyitop {
            width: 100%;
            height: 46px;
            background: #ffb559;
            display: flex;
            position: sticky;
            left: 0;
            top: 0;

            div {
              width: 33%;
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #a94800;
              line-height: 46px;
            }
          }

          .lis {
            width: 100%;
            height: 46px;
            margin: auto;
            background: #ffffff;
            display: flex;
            border-bottom: 1px;

            div {
              width: 33%;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 46px;
              text-align: center;
            }
          }

          .wu {
            width: 100%;
            // height: 50vh;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            align-content: center;
            padding-top: 100px;

            img {
              width: 200px;
              margin-bottom: 30px;
            }

            span {
              width: 100%;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
            }
          }
          .wu_center_custom {
            width: 100%;
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 100px;
            box-sizing: border-box;
            font-size: 18px;
            color: #666666;
            text-align: center;
            line-height: 28px;
          }
        }
      }
    }
  }
}
.shortlisted-query {
  width: 100%;
  max-width: 1024px;
  margin: 70px auto 0 auto;
  position: relative;
  .contentFrom_title {
    width: 265px;
    height: 52px;
    margin: auto;
    border-radius: 9px;
    background: url("~@/assets/image/icon/titlebg.png") no-repeat;
    background-size: 100% 100%;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 23px;
    line-height: 52px;
    position: absolute;
    top: -26px;
    left: 0;
    right: 0;
    margin: auto;

    text-shadow: 1.5px 1.5px 0 #ff782f, -1.5px 1.5px 0 #ff782f,
      1.5px -1.5px 0 #ff782f, -1.5px -1.5px 0 #ff782f;
  }
  .plateUlsCentent6 {
    width: 100%;
    padding: 35px 30px 20px 30px;
    border-radius: 8px 8px 8px 8px;
    box-sizing: border-box;
    background: #ffffff;

    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      box-sizing: border-box;
      gap: 20px;

      li {
        flex: 1;
        text-align: left;
        margin-bottom: 10px;

        .prompt {
          height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          line-height: 10px;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          padding-left: 13px;
          box-sizing: border-box;

          div {
            margin-right: 11px;
            text-align: center;
            line-height: 30px;
            color: #999999;
          }

          .highlight {
            color: #4d4d4d !important;
            position: relative;
          }

          .highlight:after {
            content: " ";
            width: 90%;
            height: 1px;
            background: #4d4d4d;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }

          span {
            font-size: 12px !important;
            color: #de2810;
          }
        }

        .lis {
          width: 100%;
          height: 45px;
          line-height: 45px;
          background: #f5f5f5;
          display: flex;
          border-radius: 6px 6px 6px 6px;
          // overflow: hidden;

          .lisLife {
            display: flex;
            align-items: center;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #4a4a4a;
            padding-left: 10px;

            img {
              width: 16px;
              height: 11px;
            }
          }

          .lisRight {
            width: 100%;
            height: 100%;

            input {
              width: 100%;
              height: 100%;
              padding-left: 13px;
              box-sizing: border-box;
              border: none;
              background: #f5f5f5;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
            }
            input::-webkit-input-placeholder {
              color: #999999;
            }
            /* 使用webkit内核的浏览器 */
            input:-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本4-18 */
            input::-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本19+ */
            input:-ms-input-placeholder {
              color: #999999;
            } /* IE浏览器 */
          }
        }
        .input-name {
          width: 22%;
          // height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          padding-left: 13px;
        }
        .input-name-1 {
          width: 25%;
          // height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          padding-left: 13px;
        }
        .promptInput {
          width: 100%;
          height: 45px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 3px 3px 3px 3px;
          input {
            width: 100%;
            height: 100%;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            background: #f5f5f5;
            border-radius: 3px 3px 3px 3px;
            border: none;
            padding-left: 13px;
            box-sizing: border-box;
          }

          input::-webkit-input-placeholder {
            color: #999999;
          }
          /* 使用webkit内核的浏览器 */
          input:-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本4-18 */
          input::-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本19+ */
          input:-ms-input-placeholder {
            color: #999999;
          } /* IE浏览器 */
        }

        .promptInput2 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          border-radius: 6px 6px 6px 6px;
          height: 45px;
          line-height: 45px;
          box-sizing: border-box;
          background: #f5f5f5;
          span {
            width: 100%;
            height: 100%;
          }
          .span_tw {
            color: rgb(153, 153, 153) !important;
          }
          .promptInputValue {
            width: 100%;
            height: 100%;
            padding-left: 13px;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            border-radius: 6px 6px 6px 6px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
          }
        }
      }
    }

    .uls:first-child {
      margin-right: 60px;
    }

    .but {
      width: 140px;
      height: 52px;
      background: url("~@/assets/image/icon/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      padding-bottom: 20px;
      margin: 20px auto 0 auto;
      transition: all 0.3s;
      &:active {
        transform: scale(1.06);
      }
    }
  }
}

.view_guide {
  padding: 0 8px;
  width: 180px;
  height: 40px;
  line-height: 40px;
  background: #ff7e18;
  font-size: 20px;
  font-family: PingFang SC-Semibold, PingFang SC;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  // margin: auto;
  cursor: pointer;
}

.newShortBox {
  width: 600px;
  padding-top: 24px;
  padding-bottom: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    justify-content: center;

    .lis {
      width: 100%;
      margin-bottom: 20px;
    }

    .lis:last-child {
      margin-bottom: 0px !important;
    }

    .lisCenten {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lisText2 {
      display: flex;
      justify-content: space-between;
      width: 65%;
      margin: auto;
      font-size: 14px;

      span {
        color: #ff5a25;
      }
    }

    .ulst {
      width: 80%;
      margin: auto;

      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-radius: 3px 3px 3px 3px;

        li {
          width: 32%;
          text-align: center;
          font-size: 14px;
          padding: 0 5px;
        }
        li:nth-child(2) {
          width: 36% !important;
        }
      }

      ul:nth-child(1) {
        background: #ff5a25;
        height: 30px;
        line-height: 30px;

        li {
          height: 100%;
          color: #fff;
        }
      }

      ul:nth-child(2) {
        background: #feffeb;
        font-size: 9.8px !important;
        line-height: 20px;
        margin-top: 10px;
        margin-bottom: 20px;
        padding: 10px 0;
        li {
          color: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .lisText {
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e4e4e;
      line-height: 24px;
    }

    .but {
      width: 145px;
      height: 45px;
      background: url("~@/assets/image/icon/but.png") no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 45px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      cursor: pointer;
    }
  }
}
::v-deep .CountryCodeSelectorContainer {
  width: 100px;
  .arrow-down {
    width: 12px;
    height: 12px;
  }
}

.generateHeatsBox {
  width: 960px;
  padding: 12px;
  box-sizing: border-box;
  background: #ffd123;
  border-radius: 16px 16px 16px 16px;
  .uls {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    background: #fff;

    .titleH1 {
      width: 100%;
      font-size: 24px;
      color: #ff5a25;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px 0 15px 0;

      .right_icon {
        display: flex;
        align-items: center;
        div:nth-child(3) {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:first-child {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
      }

      .left_icon {
        display: flex;
        align-items: center;
        div:first-child {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(3) {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
      }
    }

    .textCentent {
      width: 100%;
      text-align: left;
      line-height: 26px;
      font-family: PingFang SC-Medium, PingFang SC;

      .color1 {
        color: #ff5a25;
      }
      .color2 {
        color: #999999;
      }

      .font_size1 {
        font-size: 18px;
      }
      .font_size2 {
        font-size: 14px;
      }

      .titleRed {
        width: 180px;
        height: 40px;
        line-height: 40px;
        background: #ff5a25;
        border-radius: 3px 3px 3px 3px;
        text-align: center;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 12px;
      }

      .but {
        width: 180px;
        height: 40px;
        line-height: 40px;
        background: #ff7e18;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        border-radius: 3px 3px 3px 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        margin: auto;
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }
      }
    }
  }
}
.generateHeats {
  ::v-deep .van-overlay {
    z-index: 999995 !important;
  }
  ::v-deep .van-popup {
    z-index: 999999 !important;
  }
}
</style>
